import * as React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import TaxonomyGenericTeaser from './Teaser';
import TaxonomyGenericPage from './Page';
import TaxonomyGenericTitle from './Title';
import { TaxonomyGeneric } from '../../../types/uncinc_profile/taxonomy';

type TaxonomyViewmode = 'teaser' | 'page' | 'title';

interface TaxonomyGenericWrapperProps {
  entity: ImmutableEntity<TaxonomyGeneric>;
  viewMode: TaxonomyViewmode;
}

const TaxonomyGenericWrapper: React.FC<TaxonomyGenericWrapperProps> =
  ({ entity, viewMode, ...props }) => {
    switch (viewMode) {
      case 'teaser':
        return <TaxonomyGenericTeaser entity={entity} {...props} />;
      case 'title':
        return <TaxonomyGenericTitle entity={entity} {...props} />;
      case 'page':
      default:
        return <TaxonomyGenericPage entity={entity} {...props} />;
    }
  };

export default TaxonomyGenericWrapper;
